import React, { useEffect, useState } from "react";
import { List, Datagrid, TextField, DateField, FunctionField, SearchInput, SelectInput, useResourceContext, TopToolbar, ExportButton } from "react-admin";
import { Link } from "react-router-dom";
import { formatPostalCode, cleanTimeChoices, isOverdue, monthChoices, formatPhoneNumberStrict, getNameAndCompanyName } from "../common";
import { downloadCSV } from 'react-admin';
import { unparse } from 'papaparse';
import CustomCreateButton from "../components/CustomeCreateButton";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const CleanReceptHistoryList = () => {
  const resource = useResourceContext();
  const [customers, setCustomers] = useState([]);

  const CustomerFilters = [
    <SearchInput
      source="q"
      alwaysOn
      placeholder="郵便番号・住所・顧客名"
      inputProps={{ style: { fontSize: '12px' } }}
      sx={{ width: 250 }}
    />,
    <SelectInput
      source="month"
      label={<span style={{ fontSize: "12px" }}>受付月</span>}
      choices={monthChoices}
      alwaysOn
      sx={{
        ".MuiInputBase-root": { height: "35px" },
        ".MuiInputBase-input": {
          fontSize: "12px"
        },
      }}
    />
  ];

  // const customExporter = (records) => {
  //   // エクスポートするデータをカスタムフォーマットに変換
  //   const csvData = records.map(record => {

  //     return {
  //       // "受付No": String(record.number).padStart(5, "0"), 
  //       "受付日": record.receptDate ? new Date(record.receptDate).toLocaleDateString() : "",
  //       "住所": `${record.postCode ? record.postCode : ""} ${record.address ?? ""}`, 
  //       "電話番号": `${record.phone ? record.phone : record.telephone ? record.telephone : ""}`, 
  //       "顧客名": `${getNameAndCompanyName(record.surname,record.name,record.companyName)}`, // フルネーム結合
  //       "領収": record.isComplete ? "済" : "",
  //       "清掃予定日": record.exCleaningDate ? new Date(record.exCleaningDate).toLocaleDateString() : "",
  //       "清掃予定時間": record.exCleaningTime ? cleanTimeChoices.find(choice => choice.id === record.exCleaningTime).name : "",
  //       "地区": record.district ? [
  //         { id: "A地区", name: "A地区" },
  //         { id: "B地区", name: "B地区" }
  //       ].find(choice => choice.id === record.district).name : "",
  //     }

  //   });

  //   // CSV のエクスポート
  //   const csv = "\uFEFF" + unparse(csvData, { header: true });
  //   downloadCSV(csv, `清掃受付履歴_` + new Date().toLocaleDateString());
  // };


  const customExporter = (records) => {
    const csvData = records.map(record => ({
      "受付日": record.receptDate ? new Date(record.receptDate).toLocaleDateString() : "",
      "住所": `${record.postCode ?? ""} ${record.address ?? ""}${record.address2 ?? ""}${record.address3 ?? ""}${record.address4 ?? ""}${record.address5 ?? ""}`,
      "電話番号": `${record.phone ?? record.telephone ?? ""}`,
      "顧客名": getCustomer(record.customerId)?.bukken ?? "",
      "領収": record.isComplete ? "済" : "",
      "清掃予定日": record.exCleaningDate ? new Date(record.exCleaningDate).toLocaleDateString() : "",
      "清掃予定時間": record.exCleaningTime
        ? cleanTimeChoices.find(choice => choice.id === record.exCleaningTime)?.name ?? ""
        : "",
      "地区": record.district
        ? [
          { id: "A地区", name: "A地区" },
          { id: "B地区", name: "B地区" }
        ].find(choice => choice.id === record.district)?.name ?? ""
        : "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(csvData);

    // ✅ セル幅を設定
    worksheet["!cols"] = [
      { wch: 10 }, // 受付日
      { wch: 60 }, // 住所
      { wch: 15 }, // 電話番号
      { wch: 25 }, // 顧客名
      { wch: 5 },  // 領収
      { wch: 15 }, // 清掃予定日
      { wch: 12 }, // 清掃予定時間
      { wch: 10 }  // 地区
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "受付履歴");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

    saveAs(blob, `清掃受付履歴_${new Date().toLocaleDateString()}.xlsx`);
  };

  const handleRowClick = (id, basePath, record) => {
    const url = `${window.location.origin}/#/${basePath}/show/${id}`;
    const features = 'width=1200,height=800,left=200,top=100,noopener,noreferrer';
    window.open(url, '_blank', features);
    return false;
  };

  const CustomersActions = () => (
    <TopToolbar>
      <CustomCreateButton basePath="/cleanReceptHistory" />
      <ExportButton exporter={customExporter} />
    </TopToolbar>
  );

  const getCustomer = (customerId) => {
    const customer = customers.find(req => req.id === customerId);
    return customer;
  }

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/customers/clean`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        setCustomers(data);
      } catch (error) {
        console.error("ユーザー情報の取得に失敗しました:", error);
      } finally {
        // setLoading(false);
      }
    };

    fetchUser();
  }, []);


  return (
    <List filters={CustomerFilters} exporter={customExporter} actions={<CustomersActions />} sort={{ field: "receptDate", order: "ASC" }}>
      <Datagrid rowClick={(id, basePath, record) => handleRowClick(id, basePath, record)} bulkActionButtons={false} rowStyle={(record) => isOverdue(record) ? { backgroundColor: "#FFCCCC" } : {}}>
        {/* <FunctionField source="number" label="受付No" render={(record) => {
          return String(record.number).padStart(5, "0");
        }}/> */}
        <DateField source="receptDate" label="受付日" />
        <FunctionField
          label="住所"
          render={record => {
            return `${record.postCode ? record.postCode : ""} ${record.address ?? ""}${record.address2 ?? ""}${record.address3 ?? ""}${record.address4 ?? ""}${record.address5 ?? ""}`;
          }}
        />
        <FunctionField
          source="phone"
          label="電話番号"
          render={(record) => `${record.phone ? record.phone : record.telephone ? record.telephone : ""}`}
        />
        <FunctionField label="顧客名"
          render={(record) => {
            const customer = getCustomer(record.customerId);
            return <Link to={`/customers-clean/show/${record.customerId}`}>{`${customer ? customer.bukken : ""}`}</Link>;
          }}
          onClick={(e) => e.stopPropagation()}
        />
        <FunctionField
          label="清掃予定"
          render={record => {
            return `${record.isComplete ? "済" : ""}`;
          }}
        />
        <DateField source="exCleaningDate" label="清掃予定日" />
        <FunctionField
          label="清掃予定時間"
          render={record => {
            const choice = cleanTimeChoices.find(choice => choice.id === record.exCleaningTime);
            return choice ? choice.name : "";
          }}
        />
        <FunctionField
          label="地区"
          render={record => {
            const choice = [
              { id: "A地区", name: "A地区" },
              { id: "B地区", name: "B地区" }
            ].find(choice => choice.id === record.district);
            return choice ? choice.name : "";
          }}
        />
        <FunctionField
          label="汲取予定量【㎥】"
          render={record => {
            return record.exPumpingAmount ?? "";
          }}
        />
      </Datagrid>
    </List>
  );
}

export default CleanReceptHistoryList;
